import { variables } from '../common/variables';

import { cl, toggleMapList } from '../common/functions';

const search = (markersArray, markersCluster) => {
  /*------------[SEARCH] Toggle on mobile------------*/
  if (window.innerWidth >= variables.breakpoint) {
    if (variables.shortcodeSearchTypeValue !== 'custom') {
      const searchBar = document.querySelector('.leaflet-geosearch-bar:not(.leaflet-control)');
      if (searchBar) {
        const closeSearchResults = element => {
          element.innerHTML = '';
          element.classList.remove('active');
        };
        const searchElement = document.querySelector('.leaflet-geosearch-bar:not(.leaflet-control) .results');
        // prettier-ignore
        window.addEventListener("click", (event) => {
          if (event.target !== searchBar) {
            closeSearchResults(searchElement);
          }
        }, false);
        const searchContainer = document.getElementById('stores__search');
        searchContainer.innerHTML = '';
        searchContainer.appendChild(searchBar);
      }
    }
  } else {
    // prettier-ignore
    variables.storeTab.addEventListener('click', () => {
      toggleMapList(variables.storeTab, variables.mapTab, variables.storeContainer, variables.mapContainer);
    }, false);
    // prettier-ignore
    variables.mapTab.addEventListener('click', () => {
      toggleMapList(variables.mapTab, variables.storeTab, variables.mapContainer, variables.storeContainer);
    }, false);
    document.getElementById('map__stores').appendChild(document.getElementById('storePanel'));

    if (variables.shortcodeSearchTypeValue !== 'custom') {
      const searchBar = document.querySelector('.leaflet-geosearch-bar:not(.leaflet-control)');
      if (searchBar) {
        const searchContainer = document.getElementById('searchTab__search');
        searchContainer.innerHTML = '';
        searchContainer.appendChild(searchBar);
      }
    }
  }
  /*------------[SEARCH] Custom search------------*/
  if (variables.shortcodeSearchTypeValue === 'custom') {
    let searchShop;
    let typingTimer; //timer identifier
    const doneTypingInterval = 250; //time in ms (1 seconds)

    if (window.innerWidth >= variables.breakpoint) {
      searchShop = document.querySelector('#stores__search #search__shop');
    } else {
      searchShop = document.querySelector('#searchTab__search #search__shop');
    }
    //event à chaque fois qu'un caractère est tapé dans l'input
    const listElements = document.querySelectorAll('#stores__container .container__item');
    // prettier-ignore
    searchShop.addEventListener('input', () => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        if (!!listElements.length) {
          [...listElements].forEach(listElement => {
            matchingEntities(listElement);
          });
        }
        if (!!markersArray.length) {
          [...markersArray].forEach(marker => {
            matchingMarkers(marker);
          });
        }
      }, doneTypingInterval);
    }, false);

    //affiche/cache les item en fonction du match du texte de l'input
    const matchingEntities = item => {
      const normalizedString = searchShop.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const str = new RegExp(normalizedString, 'gi');
      const itemText = item.querySelector('.text__title').innerHTML.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      if (itemText.match(str)) {
        item.dataset.display = 'true';
        setTimeout(() => {
          item.style.opacity = '1';
        }, 300);
      } else {
        item.style.opacity = '0';
        setTimeout(() => {
          item.dataset.display = 'false';
        }, 300);
      }
    };

    const matchingMarkers = (marker) => {
      const normalizedString = searchShop.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const str = new RegExp(normalizedString, 'gi');
      const markerText = marker.options.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

      if (markerText.match(str)) {
        // check si des filtres ne sont pas actifs
        const filterList = document.querySelectorAll(`ul.filters__list li.list__element[data-checked="checked"]`);
        if (!!filterList.length) {
          [...filterList].forEach(filter => {
            if (marker.options.tags.includes(filter.dataset.value)) {
              markersCluster.addLayer(marker);
            }
          });
        } else {
          markersCluster.addLayer(marker);
        }
      } else {
        markersCluster.removeLayer(marker);
      }
    }
  }
};
export { search };
